import React from 'react';
import { Link } from 'react-router-dom';
import { Button } from '../ui/button';
import { useFundingRoutes } from '../../hooks/funding/useFundingRoutes';

const FundingAIAdvisorActionLink = ({ label, clientId, prompt }) => {
  const { pathFor } = useFundingRoutes();
  const params = new URLSearchParams();
  if (clientId) params.set('client_id', clientId);
  if (prompt) params.set('prompt', prompt);
  const query = params.toString();
  const href = `${pathFor('ai-advisor')}${query ? `?${query}` : ''}`;

  return (
    <Link to={href}>
      <Button variant="outline" size="sm" className="rounded-xl">{label}</Button>
    </Link>
  );
};

export default FundingAIAdvisorActionLink;
